import {
  ColorRepresentation,
  Group,
  Intersection,
  Mesh,
  Object3DEventMap,
  Raycaster,
  Sphere,
} from 'three';

import { Instances, isInstances } from './Instances.js';

export const isInstance = (object?: any): object is Instance => {
  return (object as any)?.isInstance === true;
};

const _intersects: Intersection[] = [];
const _mesh = new Mesh();
const _sphere = new Sphere();

export interface InstanceEventMap extends Object3DEventMap {
  /**
   * Triggered when a instance is ready with instances
   */
  mount: {};
}

export class Instance extends Group<InstanceEventMap> {
  // boundingSphere: Sphere | null = null;
  type = 'Instance';
  isInstance = true;
  instances: Instances | null = null;
  mounted: boolean = false;
  selected: boolean = false;
  collision: boolean = false;
  selectedColor: ColorRepresentation = 'orange';
  collisionColor: ColorRepresentation = 'red';

  // geometry: BufferGeometry | undefined;

  constructor(
    public instanceKey: number = 0,
    public color: ColorRepresentation = 'white'
  ) {
    super();
  }

  setInstances(instances: Instances) {
    this.instances = instances;
    if (!this.mounted && instances) {
      this.mounted = true;
      this.dispatchEvent({ type: 'mount' });
    }
  }

  get geometry() {
    return this.instances?.instanceGeometry;
  }

  get boundingBox() {
    return this.geometry?.boundingBox;
  }

  get boundingSphere() {
    return this.geometry?.boundingSphere;
  }

  computeBoundingBox() {
    this.geometry?.computeBoundingBox();
  }

  computeBoundingSphere() {
    this.geometry?.computeBoundingSphere();
  }

  // And this will allow the virtual instance to receive events
  raycast(raycaster: Raycaster, intersects: Intersection[]) {
    if (!this.geometry) {
      return;
    }

    // cheap bounding sphere pre-test before raycasting the full geometry,
    // pointer events raycast every instance in the scene on each move
    if (this.geometry.boundingSphere === null) {
      this.geometry.computeBoundingSphere();
    }
    _sphere.copy(this.geometry.boundingSphere!).applyMatrix4(this.matrixWorld);
    if (!raycaster.ray.intersectsSphere(_sphere)) {
      return;
    }

    _mesh.geometry = this.geometry;
    _mesh.matrixWorld.copy(this.matrixWorld);
    _mesh.layers.mask = this.layers.mask;
    _mesh.raycast(raycaster, _intersects);

    // if (this.children.indexOf(_mesh) === -1) {
    //   this.add(_mesh);
    // }

    // process the result of raycast
    for (let i = 0, l = _intersects.length; i < l; i++) {
      const intersect = _intersects[i];
      intersect.instanceId = this.instanceKey;
      intersect.object = this;
      intersects.push(intersect);
    }

    _intersects.length = 0;
  }

  get iColor(): ColorRepresentation {
    return this.selected ? this.selectedColor : this.collision ? this.collisionColor : this.color;
  }

  update() {
    if (isInstances(this.instances)) {
      // this.geometry = this.instances.geometry;
      this.instances.setMatrixAt(this.instanceKey, this.matrixWorld);
      this.instances.setColorAt(this.instanceKey, this.iColor);
    }
  }
}

export default Instance;
